import React, { useState } from "react";
import "./FormPublicacion.css";
import { AddPublicidad, UpdatePublicidad } from "../../Backend/ApiCalls";
import { resolveSponsorImage } from '../../utils/sponsorMedia';

export default function FormPublicacion({ initialData, onSubmit }) {

  // ---------------------------
  // CAMPOS BÁSICOS
  // ---------------------------
  const [title, setTitle] = useState(initialData?.title || "");
  const [description, setDescription] = useState(initialData?.description || "");
  const [link, setLink] = useState(initialData?.link || "");

  // ---------------------------
  // LOGO
  // ---------------------------
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(resolveSponsorImage(initialData?.companyLogo));

  const handleLogo = (e) => {
    const file = e.target.files[0];
    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  // ---------------------------
  // GALERÍA
  // ---------------------------
  const [galleryFiles, setGalleryFiles] = useState([]);
  const [previewGallery, setPreviewGallery] = useState((initialData?.gallery || []).map(resolveSponsorImage));

  const handleGallery = (e) => {
    const files = Array.from(e.target.files);
    setGalleryFiles(files);
    setPreviewGallery(prev => [
      ...prev,
      ...files.map(f => URL.createObjectURL(f))
    ]);
  };

  // ---------------------------
  // ENVIAR FORMULARIO
  // ---------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("title", title);
    formData.append("description", description);
    formData.append("link", link);

    // Logo (nuevo)
    if (logoFile) {
      formData.append("companyLogo", logoFile);
    } else if (initialData?.companyLogo) {
      formData.append("companyLogo", initialData.companyLogo);
    }

    // Galería existente (edición)
    if (initialData?.gallery) {
      formData.append("existingGallery", JSON.stringify(initialData.gallery));
    } else {
      formData.append("existingGallery", "[]");
    }

    // Galería nueva
    galleryFiles.forEach((file) => {
      formData.append("gallery", file);
    });

    // Crear o editar
    if (initialData) {
      await UpdatePublicidad(initialData.id, formData);
    } else {
      await AddPublicidad(formData);
    }

    onSubmit();
  };

  return (
    <form className="form-publicacion" onSubmit={handleSubmit}>
      
      <h2>{initialData ? "Editar publicación" : "Nueva publicación"}</h2>

      {/* TÍTULO */}
      <label>Título</label>
      <input
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      {/* DESCRIPCIÓN */}
      <label>Descripción</label>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      {/* LINK */}
      <label>Link (opcional)</label>
      <input
        value={link}
        onChange={(e) => setLink(e.target.value)}
      />

      {/* LOGO */}
      <label>Logo de la empresa</label>
      <input type="file" accept="image/*" onChange={handleLogo} />
      {logoPreview && (
        <img src={logoPreview} className="preview-img" alt="Preview logo" />
      )}

      {/* GALERÍA */}
      <label>Imágenes adicionales</label>
      <input type="file" accept="image/*" multiple onChange={handleGallery} />

      <div className="preview-galeria">
        {previewGallery.map((img, i) => (
          <img key={i} src={img} className="preview-img" alt="preview" />
        ))}
      </div>

      <button className="button-default">
        {initialData ? "Guardar cambios" : "Crear publicación"}
      </button>

    </form>
  );
}
